import SportsIcon from "../../assets/icons/mobile-footer-icons/sports-icon.svg";
import ClockIcon from "../../assets/icons/mobile-footer-icons/clock-icon.svg";
import HomeIcon from "../../assets/icons/mobile-footer-icons/home-icon.svg";
import PinIconWhite from "../../assets/icons/mobile-footer-icons/pin-icon-white.svg";
import PersonIcon from "../../assets/icons/mobile-footer-icons/person-icon.svg";
import {
  CRICKET_ROUTE,
  EXCHANGE_SPORTS_ROUTE,
  HOME_ROUTE,
  IN_PLAY_ROUTE,
  MOBILE_ACCOUNTS_ROUTE,
  MULTI_MARKETS_ROUTE,
} from "@hypexone/uicore";

export const mobileFooterTabs = [
  {
    title: "Sports",
    langkey:"sports",
    imageSrc: SportsIcon,
    navigationUrl: `/exchange_sports/sports/cricket`,
  },
  {
    title: "In-Play",
    langkey:"in_play",
    imageSrc: ClockIcon,
    navigationUrl: `${IN_PLAY_ROUTE}`,
  },
  {
    title: "Home",
    langkey:"home",
    imageSrc: HomeIcon,
    navigationUrl: `${HOME_ROUTE}`,
  },
  {
    title: "Multi Market",
    langkey:"multimarkets",
    imageSrc: PinIconWhite,
    navigationUrl: `${MULTI_MARKETS_ROUTE}`,
  },
  {
    title: "Account",
    langkey:"account",
    imageSrc: PersonIcon,
    navigationUrl: `${MOBILE_ACCOUNTS_ROUTE}`,
  },
];
